<script>
  import {
    Field,
    FieldActions,
    FieldError,
    FieldHeader,
    FieldLabel,
    FieldValue
  } from '@client/components/fields/standalone/base';
  import { Textarea } from '@client/components/textarea';

  export let id = null;
  export let label = null;
  export let value = null;
  export let formatValue = (val) => val || '-';
  export let allowCopy = false;

  export let validationError = undefined;

  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let ref = null;
  export let readonly = false;
  export let editing = false;
  export let blur = false;

  export let showActions = true;

  export let onChange = () => {};
  export let onUpdate = () => {};
  export let formatInput = (val) => val;

  let newValue = value;
  let disableSubmit = true;
  let error = false;

  const onEdit = () => {
    editing = true;
    setTimeout(() => ref && ref.focus(), 100);
  };

  const onChangeValue = () => {
    error = false;

    newValue = formatInput(newValue);

    if (onChange) {
      onChange(id, label, newValue);
    }
  };

  const onCancel = () => {
    editing = false;
    newValue = value;
  };

  const onSave = () => {
    value = newValue;
    editing = false;

    if (onUpdate) {
      onUpdate(id, label, value);
    }
  };

  $: disableSubmit = value === newValue;
  $: blurred = blur && !editing;
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} bind:error />
    <FieldActions
      bind:readonly
      bind:editing
      bind:disableSubmit
      {onSave}
      {onEdit}
      {onCancel}
      {showActions}
      {allowCopy}
      bind:copyValue={newValue}
    />
  </FieldHeader>
  <FieldValue bind:error bind:blur={blurred} {showActions}>
    {#if editing}
      <Textarea class="raw" {id} bind:ref bind:value={newValue} on:change={onChangeValue} on:keyup={onChangeValue} />
    {:else}
      {@html formatValue(newValue)}
    {/if}
  </FieldValue>
  <FieldError bind:error {validationError} />
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./textarea.scss"></style>
